import React, { Component } from "react";
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../theme";

class Logout extends Component {
   componentDidMount() {
	  
	 if (this.props.location.state === undefined) {
		 
			let userdetails = { user_id :  JSON.parse(JSON.parse(localStorage.getItem('persist:demo1-auth')).user)[0].id }
			fetch(process.env.REACT_APP_NODE_ENV + '/api/web/logout', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  },
			  body: JSON.stringify(userdetails)
			}).then((response) => response.json())
			  .then(data => { })
		  this.props.logout();
		 
	  }
	  else  {
		   
		   if(this.props.location.state.logintoken === 2) {
			   this.props.logout();
		   }
		   else {
		  
				let userdetails = { user_id :  JSON.parse(JSON.parse(localStorage.getItem('persist:demo1-auth')).user)[0].id }
				fetch(process.env.REACT_APP_NODE_ENV + '/api/web/logout', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(userdetails)
				}).then((response) => response.json())
				  .then(data => { })
		   }
	  }
}


  render() {
    const { hasAuthToken } = this.props;

    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
